import React, { memo } from 'react';
import { useFormContext } from 'react-hook-form';
import { M131ProductDetailModule } from '~/lib/data-contract';
import { ButtonLegacy, InputField, RawHtml } from '~/shared/components';
import { Fields, Form, useTranslation } from '~/shared/utils';
import { useModule } from '~/templates';
import { Spacer } from '~/theme';
import { StyledReserveSectionForm } from './styled';

type ReserveSectionFormProps = {
    onSubmit: (values: Fields) => void;
};

export const ReserveSectionForm = memo(({ onSubmit }: ReserveSectionFormProps) => {
    const { translate } = useTranslation();
    const { element } = useModule<M131ProductDetailModule>();
    const { reservationPolicy } = element;

    const {
        handleSubmit,
        register,
        formState: { errors },
        watch,
    } = useFormContext();

    const values = watch();

    return (
        <StyledReserveSectionForm>
            <Form.Root onSubmit={handleSubmit(onSubmit)}>
                <Form.Column>
                    <InputField
                        {...register('name')}
                        invalidMessage={errors?.name?.message}
                        autoComplete="name"
                        isActive={!!values.name}
                        label={translate('form.label.name')}
                        placeholder={translate('form.placeholder.name')}
                    />
                </Form.Column>
                <Form.Column>
                    <InputField
                        {...register('phone')}
                        invalidMessage={errors?.phone?.message}
                        autoComplete="tel-national"
                        isActive={!!values.phone}
                        type="tel"
                        label={translate('form.label.phone')}
                        placeholder={translate('form.placeholder.phone')}
                    />
                </Form.Column>
                <Form.Column>
                    <InputField
                        {...register('email')}
                        invalidMessage={errors?.email?.message}
                        isActive={!!values.email}
                        autoComplete="email"
                        label={translate('form.label.email')}
                        placeholder={translate('form.placeholder.email')}
                    />
                </Form.Column>
                <Form.Column>
                    <Spacer space="2" />
                    <ButtonLegacy type="submit">{translate('reservation.form.submit')}</ButtonLegacy>
                </Form.Column>
            </Form.Root>
            <RawHtml html={reservationPolicy} />
        </StyledReserveSectionForm>
    );
});
